import {
    createElementVNode as _$ce,
    createUnknownComponentVNode as _$cc,
} from 'intact';
import {Bubble} from 'kpc';

var _$tmp0 = {
    'variant': 'filled',
    'content': 'filled 适合强调主内容，是默认风格。'
};
var _$tmp1 = {
    'variant': 'outlined',
    'content': 'outlined 更适合信息卡片感或偏文档型内容。'
};
var _$tmp2 = {
    'variant': 'plain',
    'content': 'plain 更轻，适合弱化容器感的对话内容。'
};

export default function($props, $blocks, $__proto__) {
    $blocks || ($blocks = {});
    $props || ($props = {});
    var $this = this;
    
    return _$ce(2, 'div', [
        _$cc(Bubble, _$tmp0),
        _$cc(Bubble, _$tmp1),
        _$cc(Bubble, _$tmp2)
    ], 4, 'bubble-demo-variant');
};